export default __webpack_public_path__ + "static/media/logo_aria.decb6636.png";